import React from "react";
import PropTypes from "prop-types";

class EmbedContent extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			height: window.innerHeight - window.innerHeight * 0.05,
			width: window.innerWidth
		};
	}
	componentDidMount() {
		if (this.props.type === "code") {
			const container = document.getElementsByClassName("EmbedContent")[0];
			const range = document.createRange();
			range.setStart(container, 0);
			container.appendChild(range.createContextualFragment(this.props.url));
			setTimeout(() => {
				const evt = new Event("load");
				window.dispatchEvent(evt);
			}, 1000);
		}
	}
	render() {
		if (this.props.type.startsWith("iframe")) {
			return (
				<div className="EmbedContent">
					<iframe
						frameBorder="0"
						scrolling="no"
						allowFullScreen
						src={this.props.url}
						title="juego"
						className="our_iframe"
					/>
				</div>
			);
		} else if (this.props.type === "local") {
			return (
				<div className="EmbedContent">
					<object
						classID="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"
						codebase="https://download.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=9,0,16,0"
						id="game"
						height="100%"
						width="100%"
					>
						<param name="movie" value={this.props.url} height="100%" />
						<param name="quality" value="high" />
						<param name="wmode" value="direct" />
						<param name="allowscriptaccess" value="always" />
						<param name="wmode" value="opaque" />
						<embed
							src={this.props.url}
							height="100%"
							width="100%"
							wmode="direct"
							quality="high"
							name="FlashContent"
							allowscriptaccess="always"
							type={
								this.props.url.split(".")[
									this.props.url.split(".").length - 1
								] === "swf"
									? "application/x-shockwave-flash"
									: "application/x-director"
							}
							pluginspage="https://www.macromedia.com/go/getflashplayer"
						/>
					</object>
				</div>
			);
		} else if (this.props.type === "code") {
			return <div className="EmbedContent" />;
		}
	}
}
EmbedContent.propTypes = {
	type: PropTypes.string.isRequired,
	url: PropTypes.string.isRequired
};
EmbedContent.defaultProps = {};

export default EmbedContent;
